import { LoadingOutlined } from "@ant-design/icons";
import { CustomDropdown, PaginationComponent } from "components";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import { fetchDiscountedArticles } from "store/articles/articles.slice";
import { ArticleSortOrder, sortOrderItems } from "types/articles/SortArticle";
import { parseNumberParam } from "utils/helpers/parseParam";
import ArticlesList from "../articlesCategories/articlesPage/ArticlesList";
import "./ActionsPage.scss";

const ActionsPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch: any = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { is_loading, is_fetch, data, meta } = useSelector(
    (store: any) => store.articles.discounted_articles
  );

  const currentPage = useMemo(
    () => parseNumberParam(searchParams, "page", 1),
    [searchParams]
  );
  const pageSize = useMemo(
    () => parseNumberParam(searchParams, "take", 12),
    [searchParams]
  );
  const handlePageSizeChange = (take: string) => {
    const p = new URLSearchParams(searchParams);
    p.set("take", String(take));
    p.set("page", "1"); // resetujemo na prvu stranicu
    setSearchParams(p, { replace: true });
    window.scrollTo(0, 0);
  };
  const handlePageChange = (newPage: number) => {
    const params = new URLSearchParams(searchParams);
    params.set("page", String(newPage));
    setSearchParams(params, { replace: true });
    window.scrollTo(0, 0);
  };

  const sortOrder = useMemo(
    () => searchParams.get("sort") ?? ArticleSortOrder.Default,
    [searchParams]
  );
  const handleSortSelect = (key: string) => {
    const p = new URLSearchParams(searchParams);
    if (key === ArticleSortOrder.Default) {
      p.delete("sort");
    } else {
      p.set("sort", key);
    }
    p.set("page", "1");
    setSearchParams(p, { replace: true });
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    dispatch(
      fetchDiscountedArticles({
        max_price: undefined,
        min_price: undefined,
        order: sortOrder,
        take: pageSize,
        page: currentPage,
      })
    );
  }, [dispatch, location]);

  if (is_loading) {
    return <LoadingOutlined />;
  }

  return (
    <div className="Page">
      <div className="Page-Content">
        <h2 className="Page-Title">{t("akcije")}</h2>
        {is_fetch && (
          <>
            {data.length !== 0 ? (
              <div className="Actions-Page-Articles">
                <div className="Sort-Dropdown">
                  <CustomDropdown
                    items={sortOrderItems}
                    selectedKey={sortOrder}
                    onChange={handleSortSelect}
                    placeholder={t("Sortiranje")}
                  />
                </div>
                <ArticlesList products={data} productsLoaded={true} />
                <PaginationComponent
                  current={currentPage}
                  totalItems={meta.item_count}
                  pageSize={pageSize}
                  hasNextPage={meta.has_next_page}
                  changePageSize={handlePageSizeChange}
                  changePage={handlePageChange}
                />
              </div>
            ) : (
              <div>
                <label>Trenutno nema proizvoda na akciji</label>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default ActionsPage;
